<template>
    <div class="dashboard">
        <accounts-list></accounts-list>
    </div>
</template>

<script>
import AccountsList from '@/components/Accounts/List.vue';

export default {
    name: 'dashboard',

    metaInfo: {
        title: 'Provider snapshots - Weap.io',
    },

    components: {
        AccountsList,
    },

    computed: {
        //
    },
}
</script>
